import Members from '../../../api/Members'
import Lender from '../../../components/Finance/Lender/Lender'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import LendersAPI from '../../../api/Finance/Lenders'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useTitle from '../../../elements/Hooks/useTitle'
import { get, isEmpty, pick } from 'lodash'
import { handleResponse } from '../../../modules/Utils'
import React from 'react'
import { withRouter } from 'react-router-dom'

const memberApi = new Members()
const api = new LendersAPI()

function LendersCont(props) {
  const key = props.match.params.key

  const { fetch: fetchMember, fetching: memberFetching, object: member } = useFetchObject(() =>
    memberApi.get(key).then(handleResponse)
  )

  const { fetch: fetchLender, fetching: lenderFetching, object: lender } = useFetchObject(() => api.getMember(key))

  const { list: repsList, fetching: repsListFetching, fetch: fetchRepsList } = useFetchList(
    () => memberApi.representatives.list(member._key).then(handleResponse),
    [member],
    isEmpty(member._key)
  )

  function fetch() {
    fetchMember()
    fetchLender()
    fetchRepsList()
  }

  const fetching = memberFetching || lenderFetching || repsListFetching

  const { visible, formRef, onShow: onEdit, onCancel, update, submitting } = useModalData(
    undefined,
    api.update,
    undefined,
    fetch,
    undefined,
    undefined,
    undefined,
    undefined,
    pick(lender, ['_id', '_rev', '_key'])
  )

  useTitle(get(member, 'fn') || 'Vendor')

  return (
    <Lender
      {...{
        member,
        fetching,
        lender,
        repsList,
        fetch,
        visible,
        formRef,
        onEdit,
        onCancel,
        update,
        submitting,
      }}
    />
  )
}

export default withRouter(LendersCont)
